import React, { useState, useContext } from 'react';
import { withRouter } from "react-router-dom";
import CryptoJS from 'crypto-js';
import { AUTH } from '../../tools/ApiRoutes';
import APP from '../../tools/AppRoutes';
import Context from '../Context/SessionContext';
import '../../../styles/site.css';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import { Helmet } from 'react-helmet-async';
import Peticion from '../../ComponentesCS/Complementos/EnviarPeticion';
import Alert from '@material-ui/lab/Alert';
import moment from 'moment';
import jwtEncrypt from '../../tools/jwtEncrypt';
import { AuthService, UserService } from '../../services';
import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Cookies from 'js-cookie';
import qs from 'querystring';


// ========== CONSTANTES DE CONFIGURACIÓN ==========
const AUTH_TOKEN = process.env.REACT_APP_AUTH_TOKEN;
const VALIDATION_TOKEN = process.env.REACT_APP_VALIDATION_TOKEN;

const Login = ({ history }) => {

    // ========== VARIABLES DE ESTADO ACTIVAS ==========
    const [access, setAccess] = useState({ login: '', password: '', showPassword: false });
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
    const [userAndPass, setUserAndPass] = useState({ estatus: false, texto: 'Ingresar con usuario y contraseña' });
    const [loginMS, setLoginMS] = useState({ login: '', user: '' });
    const [microsoftLoginCode, setMicrosoftLoginCode] = useState('');
    const [microsoftName, setMicrosoftName] = useState('');

    // ========== CONTEXT Y HOOKS ACTIVOS ==========
    const { login, logout, menu, marcarMenu } = useContext(Context);

    // Obtener parámetros de autenticación de Microsoft desde múltiples fuentes
    const getAuthParams = () => {
        const windowParams = new URLSearchParams(window.location.search);
        const hashParams = new URLSearchParams(window.location.hash.replace('#', '').split('?')[1] || '');

        return { id: windowParams.get('IdSession') || hashParams.get('IdSession') };
    };

    const { id } = getAuthParams();

    // ========== FUNCIONES PRINCIPALES ACTIVAS ==========
    const handleChange = (prop) => (event) => {
        setAccess({ ...access, [prop]: event.target.value });
        checkForm();
    };

    const checkForm = () => {
        localStorage.removeItem('user');
        localStorage.removeItem('Menu');
    }

    const showToast = (message, severity = 'success') => {
        setSnackbar({
            open: true,
            message,
            severity
        });
    };

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackbar({ open: false, message: '', severity: 'success' });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const isBypass = access.isbypass;


        // Validamos usuario y contraseña


        try {
            if (isBypass) {
                const config = {
                    method: 'POST',
                    headers: {
                        'Content-Type': "application/x-www-form-urlencoded",
                        'token': AUTH_TOKEN
                    },
                    body: qs.stringify({ option: '[csAuthenticator].[dbo].selDatosEmpleadoID', id: access.login })
                };

                const res = await Peticion(config, AUTH.GetDataID);


                if (res?.data?.[0]?.IdEmpleado > 0) {
                    login(res.data[0]);
                    const pathname = `#${APP.HOME}`;
                    marcarMenu({ ...menu, pathname });
                    history.push(APP.HOME);
                } else {
                    // setMensajeError(true);
                    showToast('El usuario no es válido', 'error');
                }

                return;

            } else {
                const validationMessage = validateCredentials(access.login, access.password);
                if (validationMessage) {
                    showToast(validationMessage, 'warning');
                    return;
                }
                const res = await AuthService.login(1, access.login, access.password);

                if (res.expiresInSeconds > 0) {

                    localStorage.setItem(
                        'accessToken',
                        JSON.stringify({
                            expirationDate: moment().add(res.expiresInSeconds, 'seconds').format('YYYY-MM-DD HH:mm:ss'),
                            token: res.token,
                            refreshToken: res.refreshToken
                        })

                    );

                    const info = await UserService.userInfo(access.login);
                    const authData = {
                        NombreCompleto: info.nombre,
                        Usuario: info.login,
                        ExpirationDate: moment().add(res.expiresInSeconds, 'seconds').format('YYYY-MM-DD HH:mm:ss'),
                    }

                    login(authData);
                    const pathname = `#${APP.HOME}`;
                    marcarMenu({ ...menu, pathname });
                    history.push(APP.HOME);
                } else {
                    handleLoginFailure();
                }
            }

        } catch (error) {
            if (error?.response?.status === 401 || error?.response?.status === 403) {
                handleLoginFailure();
                return;
            }

            showToast('Ocurrió un error al intentar iniciar sesión', 'error');
        }
    }

    const validateCredentials = (login, password) => {
        if (!login) return 'Ingresa el usuario';
        if (!password) return 'Ingresa la contraseña';
        return null;
    };

    const handleLoginFailure = () => {
        localStorage.removeItem('accessToken');
        setAccess({ ...access, password: '', login: '' });
        showToast('El usuario y/o la contraseña no son válidos', 'error');
    };

    const loginChange = (event) => {
        event.preventDefault();
        if (userAndPass.estatus === false) {
            setUserAndPass({ estatus: true, texto: 'Ingresar con mi cuenta Microsoft' });
            setAccess({ ...access, isbypass: false });
        } else {
            setUserAndPass({ estatus: false, texto: 'Ingresar con usuario y contraseña' });
        }
    }

    const handleClickShowPassword = () => {
        setAccess({
            ...access,
            showPassword: !access.showPassword,
        });
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const recoverPass = (event) => {
        event.preventDefault();
        window.open('https://appsd.compusoluciones.com/csActualizaInfo/recuperar.aspx', '_blank', 'noopener,noreferrer');
    }



    // Validar que las variables de entorno estén configuradas
    if (!AUTH_TOKEN || !VALIDATION_TOKEN) {
    }

    // ========== FUNCIONES DE MICROSOFT ==========
    const processMicrosoftAuth = async ({ token, refreshToken, expiresInSeconds, user }) => {
        const expirationSeconds = Number(expiresInSeconds);

        if (!token || !refreshToken || !user || !Number.isFinite(expirationSeconds) || expirationSeconds <= 0) {
            throw new Error('Respuesta de exchange-login-code incompleta');
        }

        const expirationDate = moment().add(expirationSeconds, 'seconds').format('YYYY-MM-DD HH:mm:ss');

        localStorage.setItem(
            'accessToken',
            JSON.stringify({
                expirationDate,
                token,
                refreshToken
            })
        );

        const info = await UserService.userInfo(user);

        login({
            NombreCompleto: info.nombre,
            Usuario: info.login,
            ExpirationDate: expirationDate,
        });
        const pathname = `#${APP.HOME}`;
        marcarMenu({ ...menu, pathname });
        history.push(APP.HOME);
    };

    const resetMicrosoftLogin = () => {
        setMicrosoftLoginCode('');
        setMicrosoftName('');
    };

    const exchangeMicrosoftLoginCode = async () => {
        try {
            const response = await AuthService.exchangeLoginCode(microsoftLoginCode);
            await processMicrosoftAuth(response);
        } catch (error) {
            localStorage.removeItem('accessToken');
            resetMicrosoftLogin();
            showToast('No se pudo completar el inicio de sesión con Microsoft. Intenta nuevamente.', 'error');
        }
    };

    const microsoftIdentification = async () => {
        if (microsoftLoginCode) {
            await exchangeMicrosoftLoginCode();
            return;
        }
        try {
            const url = window.location.href;
            const res = await AuthService.loginMS(url);
            window.open(`${res.result}`, '_self');
        } catch (error) {
            showToast('Error al conectar con Microsoft', 'error');
        }
    }

    const encriptation = async (p1, p2, vn) => {
        if (!AUTH_TOKEN) {
            throw new Error('Token de autenticación no configurado');
        }

        let res;
        await fetch(AUTH.ENCRIPTACION, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'token': AUTH_TOKEN
            },
            body: JSON.stringify({
                valor: p1,
                opcion: p2
            })
        })
            .then(response => response.json())
            .then(response => {
                res = response;
            })
            .catch(error => { return ([]) });

        return res;
    }

    // ========== FUNCIONES AUXILIARES PARA VALIDACIÓN DE SESIÓN ==========
    const parseTokenDate = (tokenParts) => {
        const partesFecha = tokenParts[0].split(/[- :]/);

        const año = parseInt(partesFecha[0], 10);
        const mes = parseInt(partesFecha[1], 10) - 1; // Mes es 0-indexado
        const dia = parseInt(partesFecha[2], 10);
        let hora = parseInt(partesFecha[3], 10);
        const minutos = parseInt(partesFecha[4], 10);
        const amPm = partesFecha.slice(-2).join(' ');

        // Convertir PM a formato 24 horas
        if (amPm === "p. m." && hora !== 12) {
            hora += 12;
        } else if (amPm === "a. m." && hora === 12) {
            hora = 0;
        }

        return new Date(año, mes, dia, hora, minutos);
    }

    const isTokenValid = (fechaToken) => {
        const fechaActual = new Date();
        const diferencia = fechaActual - fechaToken;
        const DOCE_HORAS_MS = 12 * 60 * 60 * 1000;

        return diferencia <= DOCE_HORAS_MS;
    }

    const saveCookieSession = (session) => {
        const expirationDate = new Date();
        expirationDate.setTime(expirationDate.getTime() + (12 * 60 * 60 * 1000)); // 12 horas
        Cookies.set('IdSession', session, { expires: expirationDate });
    }

    const processValidSession = (tokenDesencr) => {
        const usuario = tokenDesencr[2].split('@');

        setAccess({ login: usuario[0], isbypass: true });
        setLoginMS({ login: usuario[0], user: tokenDesencr[1] });
    }

    const parameterValidation = async () => {
        try {
            // Fallback al método legacy con cookies
            const cookieSession = Cookies.get('IdSession');
            const session = id ?? cookieSession;

            if (!session) {
                return; // No hay sesión válida
            }

            // Proceso de desencriptación y validación legacy
            const res = await encriptation(session, "2");

            if (res?.message !== "Solicitud correcta") {
                return;
            }

            const sessionToken = res.data[0].Valor;
            const tokenDesencr = sessionToken.split('|');
            const fechaToken = parseTokenDate(tokenDesencr);

            if (!isTokenValid(fechaToken)) {
                return;
            }

            saveCookieSession(session);
            processValidSession(tokenDesencr);

        } catch (error) {
        }
    }    // ========== EFFECT HOOK ==========
    React.useEffect(() => {
        const currentSearch = window.location.search;
        // Algunos callbacks de Microsoft separan el último parámetro con coma.
        const normalizedSearch = currentSearch.replace(',name=', '&name=');
        const params = new URLSearchParams(normalizedSearch);
        const loginCode = params.get('loginCode');
        const name = params.get('name');
        const isMicrosoftCallback = params.has('loginCode') || params.has('name');

        logout();

        if (isMicrosoftCallback) {
            if (loginCode && name) {
                setMicrosoftLoginCode(loginCode);
                setMicrosoftName(name);
            } else {
                showToast('La respuesta de Microsoft no es válida. Intenta nuevamente.', 'error');
            }

            window.history.replaceState({}, document.title, window.location.pathname);
            return;
        }

        // Solo ejecutar validación si no hay usuario validado
        if (loginMS.user === '') {
            const processAuth = async () => {
                await parameterValidation();

                // Limpiar parámetros de URL
                const urlParams = new URLSearchParams(window.location.search);
                urlParams.delete('id');
                urlParams.delete('IdSession');

                window.history.replaceState({}, document.title, '');
            };

            processAuth();
        }
    }, []); return (
        <>
            <Helmet>
                <title>Portal de Servicios Financieros</title>
            </Helmet>

            <div className="container">
                <div className="row">
                    <div className="col">
                        <p className="areaTitulo tituloLogin">Bienvenido</p>
                    </div>
                </div>
                <div className="offset-md-4 col-md-4">
                    <form className="form-login" style={{ borderRadius: 3 }}>
                        {
                            userAndPass.estatus === false ?
                                <>
                                    {
                                        microsoftLoginCode === '' ?
                                            <></>
                                            :
                                            <div className="form-group">
                                                <div className="row">
                                                    <div className="col">
                                                        <FormControl style={{ backgroundColor: '#FFFFFF', width: '100%', marginBottom: 15 }} variant="filled" disabled={true}>
                                                            <input type='text' value={microsoftName} disabled style={{ backgroundColor: 'white', height: '39px', width: '100%', padding: '4px 12px' }}></input>
                                                        </FormControl>
                                                    </div>
                                                </div>
                                            </div>
                                    }
                                </>
                                :
                                <>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col">
                                                <FormControl style={{ backgroundColor: '#FFFFFF', width: '100%', marginBottom: 15 }} variant="filled">
                                                    <input type='text' name='txtNombre' value={access.login} onChange={handleChange('login')} placeholder='Usuario' style={{ backgroundColor: 'white', height: '39px', width: '100%', padding: '4px 12px' }}></input>
                                                </FormControl>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col">
                                                <FormControl style={{ backgroundColor: '#FFFFFF', width: '100%', borderRadius: 3 }} variant="filled">
                                                    <input
                                                        id="password"
                                                        type={access.showPassword ? 'text' : 'password'}
                                                        value={access.password}
                                                        onChange={handleChange('password')}
                                                        placeholder='Contraseña'
                                                        style={{ backgroundColor: 'white', height: '39px', width: '100%', padding: '4px 12px', borderRadius: 0 }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                handleSubmit(e);
                                                            }
                                                        }}
                                                    />
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={handleClickShowPassword}
                                                        onMouseDown={handleMouseDownPassword}
                                                        style={{
                                                            position: 'absolute',
                                                            right: '1px',
                                                            backgroundColor: 'transparent', // Fondo transparente
                                                        }}
                                                        disableRipple // Desactiva el efecto ripple de Material-UI
                                                    >
                                                        {/* {access.showPassword ? <Visibility sx={{ color: "#98999b" }} /> : <VisibilityOff sx={{ color: "#98999b" }} />} */}
                                                    </IconButton>
                                                </FormControl>

                                            </div>
                                        </div>
                                    </div>
                                </>
                        }

                        <div className="row">
                            <div className="col-sm-4 col-md-4 col-lg-4" >
                                {
                                    (userAndPass.estatus === false && (loginMS.login === '' || microsoftLoginCode !== '')) ?
                                        <Button className="botonAmarillo floatLeft" onClick={microsoftIdentification} variant="contained">Identifícate</Button>
                                        :
                                        <Button className="botonAmarillo floatLeft" onClick={handleSubmit} variant="contained">Ingresar</Button>
                                }
                            </div>
                            {
                                (userAndPass.estatus) ?
                                    <div className="col-sm-8 col-md-8 col-lg-8" style={{ textAlign: 'end' }}>
                                        {
                                            userAndPass.estatus === false ?
                                                <></>
                                                :
                                                <button type="button" onClick={recoverPass} style={{ border: 'none', padding: '0', backgroundColor: 'inherit', color: 'white' }}><span>¿Olvidaste tu contraseña?</span></button>
                                        }
                                        <button onClick={loginChange} style={{ border: 'none', padding: '0', backgroundColor: 'inherit', color: 'white' }}><span>{userAndPass.texto}</span></button>
                                    </div> :
                                    <div className="col-sm-8 col-md-8 col-lg-8" style={{ display: 'flex', flexDirection: 'column', alignItems: 'right', marginTop: 4, width: '100%' }} >
                                        {
                                            userAndPass.estatus === false ?
                                                <></>
                                                :
                                                <button type="button" onClick={recoverPass} style={{ border: 'none', padding: '0', backgroundColor: 'inherit', color: 'white' }}><span>¿Olvidaste tu contraseña?</span></button>
                                        }
                                        <button onClick={loginChange} style={{ border: 'none', padding: '0', backgroundColor: 'inherit', color: 'white' }}><span>{userAndPass.texto}</span></button>
                                    </div>
                            }
                        </div>
                    </form>
                </div>
                <div className='fontNewsGothic fontSize14 marginTop75'>
                    <center>Navegador recomendado: Google Chrome</center>
                </div>
                <Snackbar
                    className="app-toast"
                    open={snackbar.open}
                    autoHideDuration={6000}
                    onClose={handleCloseSnackbar}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                    <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} variant="filled">
                        {snackbar.message}
                    </Alert>
                </Snackbar>
            </div>
        </>
    )
}

export default React.memo(withRouter(Login));
